import { Component } from '@angular/core';

@Component({
    selector: 'app-creditos-tabs',
    templateUrl: './creditos-tabs.component.html',
    styleUrls: [],
    standalone: false
})

export class CreditosTabsComponent {

  routes: object[];

  constructor() {
    this.routes = [
      { label: 'Creditos otras entidades', link: '/finance/credits/creditsentity', enable: true },
      { label: 'Creditos con empleados', link: '/finance/credits/creditswithemployees', enable: true },
    ];
  }

}
